import { useTranslations } from 'next-intl'

import { ExitButton } from '@/components/buttons/ExitButton'
import { StripedContainer } from '@/components/StripedContainer'
import { useAppSelector } from '@/utils/useAppSelector'

import { useModalContext } from '../../contexts/ModalContext'

import styles from './Unavailable.module.scss'

export const Unavailable: React.FC = () => {
  const { closeModal } = useModalContext()
  const t = useTranslations()
  const countries = useTranslations('Countries')
  const viewerCountry = useAppSelector((state) => state.config.viewerCountry)
  const country = viewerCountry ? countries(viewerCountry.toLowerCase() as keyof IntlMessages['Countries']) : undefined

  const title = country ? t('notify_modal_title_3', { country }) : t('notify_modal_no_country_title')
  const body = country ? t('notify_modal_desc_3', { country }) : t('notify_modal_no_country_body')

  return (
    <StripedContainer containerClass={styles.Container}>
      <ExitButton data-cy="button-close-unavailable-modal" className={styles.ExitButton} onClick={closeModal} />
      <h3 className={styles.Headline}>{title}</h3>
      <p className={styles.BodyText}>{body}</p>
    </StripedContainer>
  )
}
